import { config } from '@/_helpers'
import axios from 'axios'
import { redirectAuth } from '@/plugins/redirectAuth'

axios.Axios.prototype['cacheGet'] = function(url, config = {}) {
  config.headers = { ...config.headers, 'If-None-Match': ''}
  config.withCredentials = true
  return this.get(url, config)
}

let options = {
  baseURL: config.apiUrl,
  withCredentials: true,
}

let blockRedirectAuth = false

export function checkResponse(response) {

  if(response?.data?.status == 'unauthorized') {
    if(!blockRedirectAuth) {
      redirectAuth()
      blockRedirectAuth = true
    }
  }

  else if(response.config) blockRedirectAuth = false

  return response  
}

export const $_app_server = axios.create(options)